import { InvitationService, UserService } from '@vega/services'

const profileApiUri = process.env.REACT_APP_PROFILE_API_URI

const getOptions = (baseUri) => ({ baseUri })

export const userService = new UserService(getOptions(profileApiUri))
export const invitationService = new InvitationService(getOptions(profileApiUri))
